export var libsMap = {
    echarts: 'https://staticres.linhuiba.com/libs/echarts/4.7.0/echarts.min.js',
    // amap: 'https://webapi.amap.com/maps?v=1.4.15&key=791c2bf510a9ebedc319750b350fcceb&plugin=AMap.CitySearch,AMap.Scale,AMap.OverView,AMap.ToolBar,AMap.Autocomplete,AMap.PlaceSearch,AMap.CircleEditor,AMap.PolyEditor,AMap.Geocoder,AMap.Geolocation,AMap.ToolBar,AMap.IndoorMap', // 高德地图
    'ydplayer-compatible': 'https://staticres.linhuiba.com/libs/ydplayer/3.6.5/ydplayer-compatible.js',
};
